// src/keys/sha256.ts
var K = new Uint32Array([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]);
function rotr(x, n) {
  return x >>> n | x << 32 - n;
}
function utf8Encode(s) {
  return new TextEncoder().encode(s);
}
function sha256Bytes(msg) {
  const l = msg.length;
  const bitLen = BigInt(l) * 8n;
  const withPad = new Uint8Array(l + 9 + 63 >> 6 << 6);
  withPad.set(msg);
  withPad[l] = 128;
  const bitLenView = new DataView(withPad.buffer);
  bitLenView.setUint32(withPad.length - 4, Number(bitLen & 0xffffffffn), false);
  bitLenView.setUint32(withPad.length - 8, Number(bitLen >> 32n), false);
  let h0 = 1779033703;
  let h1 = 3144134277;
  let h2 = 1013904242;
  let h3 = 2773480762;
  let h4 = 1359893119;
  let h5 = 2600822924;
  let h6 = 528734635;
  let h7 = 1541459225;
  const w = new Uint32Array(64);
  const view = new DataView(withPad.buffer);
  for (let i = 0; i < withPad.length; i += 64) {
    for (let t = 0; t < 16; t++) w[t] = view.getUint32(i + t * 4, false);
    for (let t = 16; t < 64; t++) {
      const s0 = rotr(w[t - 15], 7) ^ rotr(w[t - 15], 18) ^ w[t - 15] >>> 3;
      const s1 = rotr(w[t - 2], 17) ^ rotr(w[t - 2], 19) ^ w[t - 2] >>> 10;
      w[t] = w[t - 16] + s0 + w[t - 7] + s1 >>> 0;
    }
    let a = h0, b = h1, c = h2, d = h3, e = h4, f = h5, g = h6, h = h7;
    for (let t = 0; t < 64; t++) {
      const S1 = rotr(e, 6) ^ rotr(e, 11) ^ rotr(e, 25);
      const ch = e & f ^ ~e & g;
      const temp1 = h + S1 + ch + K[t] + w[t] >>> 0;
      const S0 = rotr(a, 2) ^ rotr(a, 13) ^ rotr(a, 22);
      const maj = a & b ^ a & c ^ b & c;
      const temp2 = S0 + maj >>> 0;
      h = g;
      g = f;
      f = e;
      e = d + temp1 >>> 0;
      d = c;
      c = b;
      b = a;
      a = temp1 + temp2 >>> 0;
    }
    h0 = h0 + a >>> 0;
    h1 = h1 + b >>> 0;
    h2 = h2 + c >>> 0;
    h3 = h3 + d >>> 0;
    h4 = h4 + e >>> 0;
    h5 = h5 + f >>> 0;
    h6 = h6 + g >>> 0;
    h7 = h7 + h >>> 0;
  }
  const out = new Uint8Array(32);
  const outView = new DataView(out.buffer);
  [h0, h1, h2, h3, h4, h5, h6, h7].forEach((x, i) => outView.setUint32(i * 4, x >>> 0, false));
  return out;
}
function bytesToHex(bytes) {
  let hex = "";
  for (let i = 0; i < bytes.length; i++) hex += bytes[i].toString(16).padStart(2, "0");
  return hex;
}
function sha256Hex(input) {
  return bytesToHex(sha256Bytes(utf8Encode(input)));
}

// src/catalog/ids.ts
function isMinted(value, prefix) {
  return value.startsWith(`${prefix}_`) && /^[0-9a-f]{64}$/.test(value.slice(prefix.length + 1));
}
function defaultTagId(name) {
  if (isMinted(name, "default_tag")) return name;
  return `default_tag_${sha256Hex(name.toLowerCase())}`;
}

// src/dust/index.ts
var BARE_TRANSFER_PROTOCOLS = /* @__PURE__ */ new Set([
  "native_transfer",
  "erc20",
  "erc721",
  "erc1155"
]);
var FALLBACK_PROTOCOL_ID = "generic";
function claimedProtocols(row) {
  const primary = row.primaryProtocolId || "";
  const out = [];
  const seen = /* @__PURE__ */ new Set();
  for (const id of [primary, ...row.protocolIds ?? []]) {
    if (!id || seen.has(id)) continue;
    seen.add(id);
    if (id === FALLBACK_PROTOCOL_ID && id !== primary) continue;
    out.push(id);
  }
  return out;
}
var DEFAULT_DUST_USD = 0.01;
function pricedAboveDust(valueUsd, floor = DEFAULT_DUST_USD) {
  return typeof valueUsd === "number" && Number.isFinite(valueUsd) && valueUsd >= floor;
}

// src/forensics/checks.generated.json
var checks_generated_default = {
  checks: [
    {
      claims: [
        "entity",
        "label",
        "tag"
      ],
      cost: "cheap",
      default_enabled: true,
      description: "Every payment it receives is forwarded, within minutes, to one exchange.",
      families: [
        "evm"
      ],
      id: "evm.exchange_deposit_address",
      lanes: [
        "pipeline",
        "research"
      ],
      params: {
        forward_ratio: {
          default: 0.9,
          high: 1,
          integer: false,
          low: 0.5
        },
        max_dwell_seconds: {
          default: 604800,
          high: 7776e3,
          integer: true,
          low: 60
        },
        min_sweeps: {
          default: 2,
          high: 1e3,
          integer: true,
          low: 2
        }
      },
      profiles: [
        "forensic"
      ],
      source_id: "forensic_deposit_address",
      subject: "address",
      tags: [
        {
          name: "exchange-deposit-address",
          severity: null,
          title: "Exchange deposit address"
        }
      ],
      title: "Exchange deposit address",
      trust: 0.85
    },
    {
      claims: [
        "label",
        "tag"
      ],
      cost: "heavy",
      default_enabled: true,
      description: "A lookalike of a wallet its victims really pay, planting bait in their history.",
      families: [
        "evm"
      ],
      id: "evm.address_poisoning",
      lanes: [
        "pipeline",
        "research"
      ],
      params: {
        min_shared_prefix: {
          default: 3,
          high: 20,
          integer: true,
          low: 3
        },
        min_shared_suffix: {
          default: 4,
          high: 20,
          integer: true,
          low: 3
        }
      },
      profiles: [
        "forensic"
      ],
      source_id: "forensic_address_poisoning",
      subject: "address",
      tags: [
        {
          name: "address_poisoning",
          severity: "high",
          title: "Address poisoning"
        }
      ],
      title: "Address poisoning",
      trust: 0.85
    },
    {
      claims: [
        "tag"
      ],
      cost: "cheap",
      default_enabled: true,
      description: "Who first funded the address \u2014 an exchange withdrawal is a KYC lead; a mixer is a warning.",
      families: [
        "evm"
      ],
      id: "evm.funding_source",
      lanes: [
        "research"
      ],
      params: {},
      profiles: [
        "forensic"
      ],
      source_id: "forensic_funding_source",
      subject: "address",
      tags: [
        {
          name: "funded-by-exchange",
          severity: null,
          title: "Funded by an exchange"
        },
        {
          name: "funded-by-bridge",
          severity: null,
          title: "Funded through a bridge"
        },
        {
          name: "funded-by-mixer",
          severity: "medium",
          title: "Funded from a mixer"
        },
        {
          name: "funded-by-sanctioned",
          severity: "high",
          title: "Funded by a sanctioned address"
        }
      ],
      title: "Funding source",
      trust: 0.8
    },
    {
      claims: [
        "tag"
      ],
      cost: "cheap",
      default_enabled: true,
      description: "Forwards nearly everything it receives within minutes to wallets that are not exchanges.",
      families: [
        "evm"
      ],
      id: "evm.pass_through",
      lanes: [
        "research"
      ],
      params: {
        forward_ratio: {
          default: 0.9,
          high: 1,
          integer: false,
          low: 0.5
        },
        max_dwell_seconds: {
          default: 86400,
          high: 7776e3,
          integer: true,
          low: 0
        },
        min_forwards: {
          default: 3,
          high: 1e3,
          integer: true,
          low: 2
        }
      },
      profiles: [
        "forensic"
      ],
      source_id: "forensic_pass_through",
      subject: "address",
      tags: [
        {
          name: "pass-through",
          severity: "low",
          title: "Pass-through wallet"
        }
      ],
      title: "Pass-through wallet",
      trust: 0.6
    },
    {
      claims: [
        "tag"
      ],
      cost: "cheap",
      default_enabled: true,
      description: "Which protocols it used, read from its own transfers against our protocol address books.",
      families: [
        "evm"
      ],
      id: "evm.protocol_usage",
      lanes: [
        "research"
      ],
      params: {},
      profiles: [
        "forensic"
      ],
      source_id: "forensic_protocol_usage",
      subject: "address",
      tags: [
        {
          name: "mixer-user",
          severity: "medium",
          title: "Used a mixer"
        },
        {
          name: "bridge-user",
          severity: null,
          title: "Used a bridge"
        }
      ],
      title: "Protocol, mixer and bridge usage",
      trust: 0.8
    },
    {
      claims: [
        "label",
        "tag"
      ],
      cost: "cheap",
      default_enabled: true,
      description: "What its code says it is: a plain wallet, a Safe, a minimal proxy, an EIP-7702 delegated account.",
      families: [
        "evm"
      ],
      id: "evm.account_type",
      lanes: [
        "research"
      ],
      params: {},
      profiles: [
        "forensic",
        "standard"
      ],
      source_id: "forensic_account_type",
      subject: "address",
      tags: [
        {
          name: "smart-account",
          severity: null,
          title: "Smart account"
        },
        {
          name: "eip7702-delegated",
          severity: null,
          title: "EIP-7702 delegated account"
        }
      ],
      title: "Account type",
      trust: 0.9
    },
    {
      claims: [
        "entity",
        "label"
      ],
      cost: "cheap",
      default_enabled: true,
      description: "A contract a known protocol factory created \u2014 a Uniswap pair, a Safe \u2014 named after it.",
      families: [
        "evm"
      ],
      id: "evm.factory_instance",
      lanes: [
        "pipeline",
        "research"
      ],
      params: {},
      profiles: [
        "forensic",
        "standard"
      ],
      source_id: "forensic_factory_instance",
      subject: "address",
      tags: [],
      title: "Factory-created contract",
      trust: 0.9
    },
    {
      claims: [
        "label",
        "tag"
      ],
      cost: "cheap",
      default_enabled: true,
      description: "A token calling itself by a registered asset's symbol or name (USDT, USDC, ETH) that it is not.",
      families: [
        "evm"
      ],
      id: "evm.counterfeit_token",
      lanes: [
        "pipeline",
        "research"
      ],
      params: {},
      profiles: [
        "forensic",
        "standard"
      ],
      source_id: "forensic_counterfeit_token",
      subject: "token",
      tags: [
        {
          name: "counterfeit-token",
          severity: "high",
          title: "Counterfeit token"
        }
      ],
      title: "Counterfeit token",
      trust: 0.9
    },
    {
      claims: [
        "tag"
      ],
      cost: "cheap",
      default_enabled: true,
      description: "A token pushed onto wallets that never asked for it: airdropped dust, a counterfeit, a provider's spam flag.",
      families: [
        "evm"
      ],
      id: "evm.spam_token",
      lanes: [
        "pipeline",
        "research"
      ],
      params: {
        min_batch_recipients: {
          default: 10,
          high: 1e4,
          integer: true,
          low: 2
        },
        min_signals: {
          default: 2,
          high: 3,
          integer: true,
          low: 2
        },
        min_unsolicited_recipients: {
          default: 20,
          high: null,
          integer: true,
          low: 1
        }
      },
      profiles: [
        "forensic",
        "standard"
      ],
      source_id: "forensic_spam_token",
      subject: "token",
      tags: [
        {
          name: "spam-token",
          severity: "low",
          title: "Spam token"
        }
      ],
      title: "Spam token",
      trust: 0.85
    },
    {
      claims: [],
      cost: "cheap",
      default_enabled: true,
      description: "How much of what it received came straight from exchanges, mixers, bridges or sanctioned addresses.",
      families: [
        "evm"
      ],
      id: "evm.exposure",
      lanes: [
        "research"
      ],
      params: {},
      profiles: [
        "forensic"
      ],
      source_id: "forensic_exposure",
      subject: "address",
      tags: [],
      title: "Direct exposure",
      trust: 0.8
    },
    {
      claims: [
        "tag"
      ],
      cost: "cheap",
      default_enabled: true,
      description: "Automated trading: a sustained burst of swaps through DEX routers, builder tips, no idle hours.",
      families: [
        "evm"
      ],
      id: "evm.trading_bot",
      lanes: [
        "research"
      ],
      params: {
        min_active_hours: {
          default: 18,
          high: 24,
          integer: true,
          low: 1
        },
        min_swaps: {
          default: 50,
          high: 1e5,
          integer: true,
          low: 10
        },
        min_swaps_per_hour: {
          default: 30,
          high: 1e5,
          integer: true,
          low: 10
        }
      },
      profiles: [
        "forensic"
      ],
      source_id: "forensic_trading_bot",
      subject: "address",
      tags: [
        {
          name: "trading-bot",
          severity: null,
          title: "Trading bot"
        }
      ],
      title: "Trading bot",
      trust: 0.6
    },
    {
      claims: [
        "label",
        "tag"
      ],
      cost: "heavy",
      default_enabled: true,
      description: "Pulls tokens out of many unrelated wallets with approvals they granted \u2014 a phishing drainer's shape.",
      families: [
        "evm"
      ],
      id: "evm.drainer",
      lanes: [
        "research"
      ],
      params: {
        min_victims: {
          default: 3,
          high: 1e3,
          integer: true,
          low: 2
        }
      },
      profiles: [
        "forensic"
      ],
      source_id: "forensic_drainer",
      subject: "address",
      tags: [
        {
          name: "drainer",
          severity: "critical",
          title: "Drainer"
        }
      ],
      title: "Drainer",
      trust: 0.6
    },
    {
      claims: [
        "tag"
      ],
      cost: "cheap",
      default_enabled: true,
      description: "Claims airdrops from many distributors and passes them on to one collector.",
      families: [
        "evm"
      ],
      id: "evm.airdrop_farmer",
      lanes: [
        "research"
      ],
      params: {
        min_claims: {
          default: 5,
          high: 1e3,
          integer: true,
          low: 3
        }
      },
      profiles: [
        "forensic"
      ],
      source_id: "forensic_airdrop_farmer",
      subject: "address",
      tags: [
        {
          name: "airdrop-farmer",
          severity: "low",
          title: "Airdrop farmer"
        }
      ],
      title: "Airdrop farmer",
      trust: 0.6
    },
    {
      claims: [
        "entity",
        "label",
        "tag"
      ],
      cost: "heavy",
      default_enabled: true,
      description: "Receives sweeps from many deposit-shaped addresses \u2014 an exchange or custodian hot wallet.",
      families: [
        "evm"
      ],
      id: "evm.consolidation_wallet",
      lanes: [
        "pipeline",
        "research"
      ],
      params: {
        max_shared_funder_share: {
          default: 0.5,
          high: 0.5,
          integer: false,
          low: 0.1
        },
        min_deposit_senders: {
          default: 3,
          high: 1e3,
          integer: true,
          low: 2
        }
      },
      profiles: [
        "forensic"
      ],
      source_id: "forensic_consolidation_wallet",
      subject: "address",
      tags: [
        {
          name: "consolidation-wallet",
          severity: null,
          title: "Consolidation (hot) wallet"
        }
      ],
      title: "Consolidation wallet",
      trust: 0.85
    },
    {
      claims: [
        "label"
      ],
      cost: "cheap",
      default_enabled: true,
      description: "The ENS name the address declares as its own \u2014 its primary name, verified both ways.",
      families: [
        "evm"
      ],
      id: "evm.ens_name",
      lanes: [
        "research"
      ],
      params: {},
      profiles: [
        "forensic",
        "standard"
      ],
      source_id: "forensic_ens_name",
      subject: "address",
      tags: [],
      title: "ENS name",
      trust: 0.85
    },
    {
      claims: [
        "tag"
      ],
      cost: "cheap",
      default_enabled: true,
      description: "Deployed contracts the catalog calls counterfeit tokens, spam tokens or drainers.",
      families: [
        "evm"
      ],
      id: "evm.scam_deployer",
      lanes: [
        "pipeline",
        "research"
      ],
      params: {
        min_scam_contracts: {
          default: 1,
          high: 100,
          integer: true,
          low: 1
        },
        min_without_counterfeit: {
          default: 2,
          high: 100,
          integer: true,
          low: 2
        }
      },
      profiles: [
        "forensic",
        "standard"
      ],
      source_id: "forensic_scam_deployer",
      subject: "address",
      tags: [
        {
          name: "scam-deployer",
          severity: "high",
          title: "Scam deployer"
        }
      ],
      title: "Scam deployer",
      trust: 0.85
    }
  ]
};
var FORENSIC_CHECKS = Object.freeze(
  checks_generated_default.checks.map(
    (c) => Object.freeze({ ...c, params: Object.freeze({ ...c.params }) })
  )
);
var BY_ID = new Map(FORENSIC_CHECKS.map((c) => [c.id, c]));
function forensicCheck(id) {
  return BY_ID.get(id);
}
function requireForensicParam(checkId, name) {
  const param = forensicCheck(checkId)?.params[name];
  if (!param) {
    throw new Error(
      `${checkId} declares no param ${JSON.stringify(name)} in the forensic check snapshot \u2014 regenerate checks.generated.json (pnpm gen:types) or fix the reader`
    );
  }
  return param;
}
function clampForensicParam(param, value) {
  const whole = param.integer ? Math.trunc(value) : value;
  const floor = Math.max(param.low, whole);
  return param.high === null ? floor : Math.min(param.high, floor);
}

// src/poisoning/index.ts
var POISONING_CHECK_ID = "evm.address_poisoning";
var POLICY_PARAMS = Object.freeze({
  minSharedPrefix: "min_shared_prefix",
  minSharedSuffix: "min_shared_suffix"
});
var POISONING_POLICY_PARAMS = Object.freeze({
  minSharedPrefix: requireForensicParam(POISONING_CHECK_ID, POLICY_PARAMS.minSharedPrefix),
  minSharedSuffix: requireForensicParam(POISONING_CHECK_ID, POLICY_PARAMS.minSharedSuffix)
});
var DEFAULT_POISONING_POLICY = Object.freeze({
  minSharedPrefix: POISONING_POLICY_PARAMS.minSharedPrefix.default,
  minSharedSuffix: POISONING_POLICY_PARAMS.minSharedSuffix.default
});
function poisoningPolicyFromParams(params) {
  const read = (field) => {
    const value = params?.[POLICY_PARAMS[field]];
    return typeof value === "number" && Number.isFinite(value) ? value : DEFAULT_POISONING_POLICY[field];
  };
  return { minSharedPrefix: read("minSharedPrefix"), minSharedSuffix: read("minSharedSuffix") };
}
function clampPoisoningPolicy(policy) {
  return {
    minSharedPrefix: clampForensicParam(POISONING_POLICY_PARAMS.minSharedPrefix, policy.minSharedPrefix),
    minSharedSuffix: clampForensicParam(POISONING_POLICY_PARAMS.minSharedSuffix, policy.minSharedSuffix)
  };
}
function poisoningPolicyWithinLimits(policy) {
  return Object.keys(POLICY_PARAMS).every((field) => {
    const value = policy[field];
    return Number.isFinite(value) && clampPoisoningPolicy(policy)[field] === value;
  });
}
var POISONING_CATALOG_TAGS = Object.freeze(
  (forensicCheck(POISONING_CHECK_ID)?.tags ?? []).map((tag) => tag.name)
);
var POISONING_TAG_KEYS = new Set(
  POISONING_CATALOG_TAGS.flatMap((name) => [foldTag(name), defaultTagId(name)])
);
function foldTag(value) {
  return value.trim().toLowerCase().replace(/[\s-]+/g, "_");
}
function isPoisoningCatalogTag(value) {
  const text = (value ?? "").trim();
  if (!text) return false;
  return POISONING_TAG_KEYS.has(text) || POISONING_TAG_KEYS.has(foldTag(text));
}
var EVM_ADDRESS = /^0x[0-9a-f]{40}$/;
function evmAddress(address) {
  const a = (address ?? "").toLowerCase();
  return EVM_ADDRESS.test(a) ? a : null;
}
var normalise = evmAddress;
function sharedAffixes(a, b) {
  const x = normalise(a);
  const y = normalise(b);
  if (!x || !y) return null;
  const bx = x.slice(2);
  const by = y.slice(2);
  let prefix = 0;
  while (prefix < bx.length && bx[prefix] === by[prefix]) prefix += 1;
  let suffix = 0;
  while (suffix < bx.length && bx[bx.length - 1 - suffix] === by[by.length - 1 - suffix]) suffix += 1;
  return { prefix, suffix };
}
function isLookalike(a, b, policy = DEFAULT_POISONING_POLICY) {
  const shared = sharedAffixes(a, b);
  if (!shared) return false;
  if (shared.prefix === 40) return false;
  return shared.prefix >= policy.minSharedPrefix && shared.suffix >= policy.minSharedSuffix;
}
function deriveImpersonations(rows, read, subjects, policy = DEFAULT_POISONING_POLICY, catalogued) {
  const subjectSet = /* @__PURE__ */ new Set();
  for (const s of subjects) {
    const a = normalise(s);
    if (a) subjectSet.add(a);
  }
  if (subjectSet.size === 0) return /* @__PURE__ */ new Map();
  const genuine = /* @__PURE__ */ new Set();
  const unprovenSenders = /* @__PURE__ */ new Set();
  const realSenders = /* @__PURE__ */ new Set();
  for (const row of rows) {
    const candidate = read(row);
    const from = normalise(candidate.fromAddress);
    const to = normalise(candidate.toAddress);
    if (!from || !to || from === to) continue;
    if (subjectSet.has(from) && !subjectSet.has(to)) {
      if (!catalogued?.has(to)) genuine.add(to);
      continue;
    }
    if (subjectSet.has(to) && !subjectSet.has(from)) {
      if (catalogued?.has(from)) {
        unprovenSenders.add(from);
      } else if (pricedAboveDust(candidate.valueUsd) || candidate.provenValue === true) {
        genuine.add(from);
        realSenders.add(from);
      } else {
        unprovenSenders.add(from);
      }
    }
  }
  const out = /* @__PURE__ */ new Map();
  for (const sender of unprovenSenders) {
    if (realSenders.has(sender) || subjectSet.has(sender)) continue;
    let best = null;
    for (const target of genuine) {
      if (target === sender || !isLookalike(sender, target, policy)) continue;
      const shared = sharedAffixes(sender, target);
      if (!best || shared.prefix + shared.suffix > best.prefix + best.suffix) {
        best = { sender, mimics: target, ...shared };
      }
    }
    if (best) out.set(sender, best);
  }
  return out;
}
function short(address, prefix, suffix) {
  const head = Math.max(4, prefix);
  const tail = Math.max(4, suffix);
  return `0x${address.slice(2, 2 + head)}\u2026${address.slice(-tail)}`;
}
function revealing(address, prefix, suffix) {
  const body = address.slice(2);
  const head = Math.max(4, prefix + 2);
  const tail = Math.max(4, suffix + 2);
  if (head + tail >= body.length) return address;
  return `0x${body.slice(0, head)}\u2026${body.slice(body.length - tail)}`;
}
function namesNothingBeyondATransfer(row) {
  const claimed = claimedProtocols(row);
  return claimed.length > 0 && claimed.every((id) => id === FALLBACK_PROTOCOL_ID || BARE_TRANSFER_PROTOCOLS.has(id));
}
function poisoningReason(row, impersonations, catalogued) {
  const sender = normalise(row.fromAddress);
  if (!sender) return null;
  const hit = impersonations.get(sender);
  const tagged = catalogued?.has(sender) === true;
  if (!hit && !tagged) return null;
  if (pricedAboveDust(row.valueUsd)) return null;
  if (row.provenValue === true) return null;
  if (!namesNothingBeyondATransfer(row)) return null;
  if (!hit) {
    return `Sent from ${sender}, which the catalog tags as an address-poisoning lookalike (${CATALOGUED_BY}). Address poisoning: the transfer plants the lookalike in this history so a later copy-paste pays it \u2014 compare any address copied from here character by character against the one you mean to pay.`;
  }
  const look = revealing(hit.sender, hit.prefix, hit.suffix);
  const real = revealing(hit.mimics, hit.prefix, hit.suffix);
  const disguise = short(hit.sender, hit.prefix, hit.suffix);
  return `Sent from ${look}, a lookalike of ${real} \u2014 an address this history genuinely transacted with. Both display as ${disguise} (${hit.prefix} leading and ${hit.suffix} trailing characters match), which is what the attack relies on. Address poisoning: the transfer plants the lookalike so a later copy-paste pays it.` + (tagged ? ` The catalog tags the sender as an address-poisoning lookalike too.` : "");
}
var CATALOGUED_BY = "its own activity across other wallets, or an explorer's report";
function paidLookalikeReason(row, impersonations, subjects, catalogued) {
  const from = normalise(row.fromAddress);
  const to = normalise(row.toAddress);
  if (!from || !to || !subjects.has(from)) return null;
  const hit = impersonations.get(to);
  if (!hit && catalogued?.has(to) !== true) return null;
  if (!pricedAboveDust(row.valueUsd) && row.provenValue !== true) return null;
  if (!hit) {
    return `Paid ${to}, which the catalog tags as an address-poisoning lookalike (${CATALOGUED_BY}). This is what address poisoning plants the lookalike for: the funds went to the impersonator, not the payee it imitates.`;
  }
  const look = revealing(hit.sender, hit.prefix, hit.suffix);
  const real = revealing(hit.mimics, hit.prefix, hit.suffix);
  const disguise = short(hit.sender, hit.prefix, hit.suffix);
  return `Paid ${look}, a lookalike of ${real} \u2014 the address this history genuinely paid. Both display as ${disguise}. This is what address poisoning plants the lookalike for: the funds went to the impersonator, not the intended payee.`;
}
var SPOOF_BATCH_MIN_SENDERS = 3;
var ZERO_ADDRESS = "0x0000000000000000000000000000000000000000";
var TOKEN_KINDS = /* @__PURE__ */ new Set(["erc20", "nft"]);
function isZero(raw) {
  const text = (raw ?? "").trim();
  if (!/^(0x[0-9a-f]+|\d+)$/i.test(text)) return false;
  try {
    return BigInt(text) === 0n;
  } catch {
    return false;
  }
}
function fabricatesSender(leg, called) {
  return writesTheCalledContractsLedger(leg, called) || movesNothing(leg, called);
}
function writesTheCalledContractsLedger(leg, called) {
  const target = normalise(called);
  const from = normalise(leg.from);
  if (target === null || !from || from === target) return false;
  return normalise(leg.token) === target;
}
function movesNothing(leg, called) {
  const from = normalise(leg.from);
  if (!from || from === normalise(called)) return false;
  return isZero(leg.value);
}
function spoofedTransfers(input) {
  const signer = normalise(input.signer);
  const called = normalise(input.called);
  const claimed = [];
  for (const t of input.transfers) {
    if (!TOKEN_KINDS.has(String(t.kind ?? ""))) continue;
    const from = normalise(t.from);
    const to = normalise(t.to);
    if (!from || from === ZERO_ADDRESS || from === signer) continue;
    claimed.push({ ...t, from, to, token: normalise(t.token) });
  }
  const count = (legs) => ({
    senders: new Set(legs.map((l) => l.from)).size,
    recipients: new Set(legs.map((l) => l.to).filter(Boolean)).size
  });
  const emittedByCalled = claimed.filter((l) => writesTheCalledContractsLedger(l, called));
  const batch = count(emittedByCalled);
  if (batch.senders >= SPOOF_BATCH_MIN_SENDERS) {
    return {
      kind: "batch",
      legs: emittedByCalled,
      ...batch,
      reason: `The contract this transaction called logged ${emittedByCalled.length} transfers of its own token claiming to come from ${batch.senders} different wallets, none of which signed it. A token only moves a holder's balance on that holder's signature or approval, so these entries are fabricated \u2014 the way an address-poisoning campaign plants lookalike senders in ${batch.recipients} wallet${batch.recipients === 1 ? "'s" : "s'"} histories at once. Do not copy an address from these transfers.`
    };
  }
  const zero = claimed.filter((l) => movesNothing(l, called));
  if (zero.length > 0) {
    const z = count(zero);
    return {
      kind: "zero_value",
      legs: zero,
      ...z,
      reason: `${zero.length} zero-value transfer${zero.length === 1 ? "" : "s"} name${zero.length === 1 ? "s" : ""} a sender that did not sign this transaction. Moving nothing needs no approval, which is why address poisoning uses it: the recipient's history gains an entry that looks like a payment from a lookalike. Do not copy an address from ${zero.length === 1 ? "it" : "them"}.`
    };
  }
  return null;
}

export { DEFAULT_POISONING_POLICY, POISONING_CATALOG_TAGS, POISONING_CHECK_ID, POISONING_POLICY_PARAMS, SPOOF_BATCH_MIN_SENDERS, clampPoisoningPolicy, deriveImpersonations, evmAddress, fabricatesSender, isLookalike, isPoisoningCatalogTag, paidLookalikeReason, poisoningPolicyFromParams, poisoningPolicyWithinLimits, poisoningReason, sharedAffixes, spoofedTransfers };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map